(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('Fixation', Fixation);

    Fixation.$inject = ['$resource', 'DateUtils'];

    function Fixation ($resource, DateUtils) {
        var resourceUrl =  'api/fixations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                        data.fixDate = DateUtils.convertLocalDateFromServer(data.fixDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.fixDate = DateUtils.convertLocalDateToServer(data.fixDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.fixDate = DateUtils.convertLocalDateToServer(data.fixDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
